module.exports = __webpack_public_path__ + "static/media/am-teams.409f62f0.svg";